import 'react-color-palette/css';
import './ColorSelector.css';

import { FC, useRef } from 'react';
import { ColorPicker, useColor } from 'react-color-palette';
type ColorPickerProps = {
  currentColor: string;
  setCurrentColor: (color: string) => void;
};

const ColorSelector: FC<ColorPickerProps> = ({ currentColor, setCurrentColor }) => {
  const [color, setColor] = useColor(currentColor || '#323231');
  const inputRef = useRef<HTMLInputElement>(null);
  const colors = [
    { name: 'black', value: '#323231' },
    { name: 'white', value: '#FFFFFF' },
    { name: 'lightGray', value: '#9E9E9D' },
    { name: 'teal', value: '#1E565B' },
    { name: 'lightTeal', value: '#668C90' },
    { name: 'green', value: '#657666' },
    { name: 'lightGreen', value: '#95A198' },
    { name: 'vibrantBlue', value: '#60C4E2' },
    { name: 'lightBlue', value: '#91D2E5' },
    { name: 'yellow', value: '#F4BE4D' },
    { name: 'lightYellow', value: '#F1D087' },
    { name: 'red', value: '#E84E45' },
    { name: 'lightRed', value: '#EE8880' },
    { name: 'darkBlue', value: '#3E619F' },
    { name: 'softBlue', value: '#7495BC' },
  ];

  return (
    <div className="bg-black rounded-md">
      <ColorPicker color={color} onChange={(color) => setCurrentColor(color.hex)} hideAlpha hideInput />
      <div className=" flex flex-wrap w-[260px] h-auto gap-x-0.5 gap-y-1 px-2 pt-2 ">
        {colors.map((color, index) => {
          return (
            <button
              key={index}
              className={`${currentColor == color.value ? 'bg-white' : ''} p-1 rounded-md `}
              onClick={() => setCurrentColor(color.value)}
            >
              <div
                className={`flex justify-center items-center h-5 w-5 rounded-full border  border-slate-800 `}
                style={{ backgroundColor: color.value }}
              ></div>
            </button>
          );
        })}
      </div>

      <div className="w-full p-2 ">
        <input
          id="color_picker"
          type="text"
          ref={inputRef}
          placeholder="#000000"
          value={currentColor}
          className="w-full p-2 bg-slate-700 text-white outline-none rounded-md"
          onChange={(e) => {
            setCurrentColor(e.target.value);
          }}
        ></input>
      </div>
    </div>
  );
};

export default ColorSelector;
